/*
 * @Author: liumingyang 18268117011@163.com
 * @Date: 2026-08-12 19:55:59
 * @LastEditors: liumingyang 18268117011@163.com
 * @LastEditTime: 2026-08-13 16:23:36
 * @FilePath: \databrain-main-frame\src\pages\home\pages\studio\inGameAnalytics\components\InGameNoPermissionState\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'umi';
import { Bubble } from 'tea-component';
import NoData from '@home/components/NavHeader/sreachContext/components/NoData';
import { IS_GLOBAL, LANGUAGE_EN } from '@home/_config/config';
import { getGamePermissionContact } from '@home/services/studio';
import { StudioContext } from '@/pages/home/pages/studio/context';
import './index.scss';
/**
 * 游戏内分析模块无权限状态：展示经分业务负责人联系人（无默认联系人）
 */
const InGameNoPermissionState: React.FC = () => {
  const { formatMessage, locale } = useIntl();
  const { currentGame } = useContext(StudioContext);
  const [contactEmails, setContactEmails] = useState<string[]>([]);

  const studioCode = currentGame?.studio_code;
  const gameCode = currentGame?.specialGameCode || currentGame?.game_code;

  useEffect(() => {
    if (!studioCode || !gameCode) {
      setContactEmails([]);
      return;
    }

    let cancelled = false;
    getGamePermissionContact({
      studio_code: studioCode,
      game_code: gameCode,
    })
      .then((res) => {
        if (cancelled) return;
        const emails = (res?.emails || []).filter((email: string) => !!email);
        setContactEmails(emails);
      })
      .catch(() => {
        if (cancelled) return;
        setContactEmails([]);
      });

    return () => {
      cancelled = true;
    };
  }, [studioCode, gameCode]);

  const text = useMemo(() => {
    if (!contactEmails.length) {
      return formatMessage({ id: 'dbh_studio_no_permission_view' });
    }

    const isEnglish = locale === LANGUAGE_EN;
    // 正文：WOA 中文用顿号，其余用逗号
    // 浮窗：WOA 与正文一致；Global 分号分隔且一邮箱一行
    const separator = IS_GLOBAL || isEnglish ? ',' : '、';
    const limit = IS_GLOBAL ? 2 : 5;
    const isTruncated = contactEmails.length > limit;
    const visibleText =
      contactEmails.slice(0, limit).join(separator) + (isTruncated ? '...' : '');
    const tooltipContent = (
      <div className="dbh-in-game-no-permission-state__tooltip">
        {IS_GLOBAL
          ? contactEmails.map((email, index) => (
            <div key={`${email}-${index}`}>
              {email}
              {index < contactEmails.length - 1 ? ';' : ''}
            </div>
          ))
          : contactEmails.join(separator)}
      </div>
    );

    const contactNode = isTruncated ? (
      <Bubble
        dark
        overlayClassName="dbh-in-game-no-permission-state__bubble"
        content={tooltipContent}
      >
        <strong className="dbh-in-game-no-permission-state__contact">
          {visibleText}
        </strong>
      </Bubble>
    ) : (
      <strong className="dbh-in-game-no-permission-state__contact">
        {visibleText}
      </strong>
    );

    const messageId = IS_GLOBAL
      ? 'dbh_studio_in_game_no_permission_global'
      : 'dbh_studio_in_game_no_permission_woa';

    return formatMessage({ id: messageId }, { contact: contactNode });
  }, [contactEmails, formatMessage, locale]);

  return (
    <NoData
      className="dbh-studio-state dbh-in-game-no-permission-state"
      title=""
      text={text}
    />
  );
};

export default InGameNoPermissionState;
